import React from 'react';
import dynamicLinks from '@react-native-firebase/dynamic-links';
import { extractQueryParamaters } from '../url-handling-utils';

import { Linking, Platform } from 'react-native';
import { addDeepLinkParams } from './actions';
import { connect } from 'react-redux';
import { Logger } from '../Logger';
import { ENVIRONMENT } from '../../config';
import { NavigatorService } from '../NavigatorService';

export const DeepLinkQueryParamsToStateHOC = (Component) => {
  return connect()(class DeepLinkQueryParamsToState extends React.Component {
    state = {
      deeplinkQueryParams: {},
    };

    componentDidMount = async () => {
      Linking.addEventListener('url', this.handleLink);
      let firebaseDeeplinkUrl;
      if (Platform.OS !== 'web') {
        try {
          firebaseDeeplinkUrl = await dynamicLinks().getInitialLink();
          this.unsubscribeFirebaseLink = dynamicLinks().onLink((dynamicLink) => {
            this.handleDeepLink(dynamicLink.url)
          });
        } catch (e) {
          Logger.notify(e);
        }
      }

      const url = await Linking.getInitialURL();
      const dynamicLinkUrl = firebaseDeeplinkUrl ? firebaseDeeplinkUrl.url : null;
      this.handleDeepLink(dynamicLinkUrl || url);
    }

    componentWillUnmount = () => {
      Linking.removeEventListener('url', this.handleLink);
      if (this.unsubscribeFirebaseLink) {
        this.unsubscribeFirebaseLink();
      }
    }

    handleLink = (e) => {
      this.handleDeepLink(e.url);
    }

    handleDeepLink = async (url) => {
      if (!url) {
        return;
      }
      Logger.debug(`DeepLinkQueryParamsToState.handleDeepLink: ${url}`);

      const params = extractQueryParamaters(url);

      params.wasDeepLink = Object.keys(params).length !== 0 && (
        params['planId'] != undefined ||
        params['invitationCode'] != undefined ||
        params['loginWithToken'] ||
        params.gymName ||
        params.workoutInviteId ||
        params.influencerId ||
        params.continueSignupToken
      );

      if (params.devToolsToggling) {
        this.handleDebugLinks(params.devToolsToggling);
        delete params.devToolsToggling;
      }

      this.props.dispatch(addDeepLinkParams(params));
    }

    handleDebugLinks(debugParams) {
      ENVIRONMENT.toggled = ENVIRONMENT.toggled || (debugParams.environment === 'toggled'); // elite only, standard does not refresh
    }

    render() {
      return (
        <Component ref={(navigator) => navigator && NavigatorService.setTopLevelNavigatorContainerOne(
          navigator.navigation || navigator,
        )} {...this.props} />
      );
    }
  });
};
